<template>
  <div class="set-tall">
    <p class="who">你的身高</p>
    <div class="choose-con">

      <van-picker :columns="tallArray" :visible-item-count="3" :default-index="tallDefaultIndex" ref="tallPicker" @change="tallChange"/>

      <p class="select-date-tip">上下滑动选择身高</p>
      <p class="cautious">选择后不可更改哦，请谨慎选择</p>
      <div class="deals" @click="isAgreeDeal = !isAgreeDeal">
        <span class="checkbox"
          :class="{'checked': isAgreeDeal, 'focus': isFocus}"
        >
          <img src="~@/assets/img/tick.png" alt="" class="tick" />
        </span>
        <span class="word">请认真阅读并同意</span>
        <router-link class="deal-link" to="/userDeal.html" @click.native.stop="">《Hello部落用户协议》</router-link>
      </div>
      <a class="content-btn selected" href="javascript:;" @click="complete">完成</a>
    </div>

    <van-dialog v-model="isShowConfirmPop" confirmButtonText="确认无误，继续注册" @confirm="submit">
      <div id="confirmInfo">
        <p class="title">注册信息注册后无法更改，请核对</p>
        <p class="sub-title">若信息有误，可以点击修改</p>
        <router-link class="confirm-item" to="/setUserData/sex.html">
          <span class="key">性别</span>
          <p class="val-con">
            <span class="val">{{tempData.sex == 1 ? '男' : '女'}}</span>
            <img src="~@/assets/img/arrow-enter.png" alt="" class="icon" />
          </p>
        </router-link>
        <router-link class="confirm-item" to="/setUserData/education.html">
          <span class="key">学历</span>
          <p class="val-con">
            <span class="val">{{educationMap[tempData.education]}}</span>
            <img src="~@/assets/img/arrow-enter.png" alt="" class="icon" />
          </p>
        </router-link>
        <router-link class="confirm-item" to="/setUserData/birthday.html">
          <span class="key">生日</span>
          <p class="val-con">
            <span class="val">{{tempData.birthday}}</span>
            <img src="~@/assets/img/arrow-enter.png" alt="" class="icon" />
          </p>
        </router-link>
        <div class="confirm-item" @click="isShowConfirmPop=false">
          <span class="key">身高</span>
          <p class="val-con">
            <span class="val">{{tempData.high}}</span>
            <img src="~@/assets/img/arrow-enter.png" alt="" class="icon" />
          </p>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { setCookie, getCookie, delCookie } from '@/utils/tools'
export default {
  computed: {
    ...mapGetters({
      userId: 'userId'
    }),
    ...mapState({
      educationMap: 'educationMap'
    })
  },
  data () {
    return {
      tallArray: Array.from(Array(81), (v, k) => k + 120 + 'cm'),
      tallDefaultIndex: null,
      isAgreeDeal: false,
      isFocus: false,
      high: null,
      tempData: {},
      isShowConfirmPop: false,
    }
  },
  methods: {
    ...mapActions({
      fetchUserData: 'fetchUserData'
    }),
    tallChange (picker, value, index) {
      const val = parseInt(value)
      if (!val) return
      this.high = val
      setCookie('high', val)
    },
    complete () {
      if (!this.isAgreeDeal) {
        this.$toast('请先勾选用户协议')
        this.isFocus = true
        return
      }

      let sex = getCookie('sex')
      let education = getCookie('education')

      if (!sex) {
        return this.$toast('未选择性别')
      }
      if (!education) {
        return this.$toast('未选择学历')
      }
      if (!this.high) {
        return this.$toast('未选择身高')
      }

      let date = new Date(getCookie('birthday'))
      let tempData = {
        sex,
        education,
        birthday: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`,
        high: this.high,
        // 更新状态至已设置前置资料
        status: 4
      }
      this.tempData = tempData
      this.isShowConfirmPop = true
      // this.submit(tempData)
    },
    submit () {
      this.$root.openLoading()
      this.$http(`/api/member/save`,
        this.tempData
      ).then(res => {
        this.$root.closeLoading()
        if (res.code === '0000') {
          this.fetchUserData().then(res => {
            delCookie('sex')
            delCookie('education')
            delCookie('birthday')
            this.$router.replace('/setUserData/phone.html')
          })
        } else {
          this.$toast(res.msg)
        }
      }, err => {
        this.$toast(err)
        this.$root.closeLoading()
      })
    }
  },
  mounted () {
    let high = getCookie('high')
    if (high) {
      this.high = parseInt(high)
      this.tallDefaultIndex = parseInt(high) - 120
    } else {
      this.high = 170
      this.tallDefaultIndex = 50
    }
  },
  beforeRouterLeave () {
    this.isShowConfirmPop = false
  }
}
</script>

<style lang="scss">
#confirmInfo {
  padding: 0 40px;
  .title {
    font-size: 28px;
    line-height: 46px;
  }
  .sub-title {
    margin-bottom: 34px;
    color: #9B9BA1;
    font-size: 28px;
    line-height: 46px;
  }
  .confirm-item {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    padding: 18px 24px 18px 40px;
    border: 1px solid #979797;
    border-radius: 8px;
    color: #4A4A4A;
    .icon {
      margin-left: 16px;
      width: 10px;
    }
    .val-con {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
    }
    .key {
      font-size: 28px;
      line-height: 36px;
    }
  }
}
</style>